import React from "react"

const Intrests = () => {
    return (
      <div>
        <section class="resume-section" id="interests">
          <div class="resume-section-content">
            <h2 class="mb-5">Interests</h2>
            <p>
            Apart from my passion for developing, I enjoy engaging in activities that allow me to further enhance my programming skills. One of my favorite pastimes is participating in hackathons, where I can work alongside other like-minded individuals to develop innovative solutions to real-world problems. Additionally, I find great enjoyment in competitive programming on platforms such as CodeChef and LeetCode. These activities challenge me to continually improve my coding abilities and to think creatively when it comes to problem-solving. Overall, I view these experiences as valuable opportunities to push my limits and to grow as a developer.
            </p>
          </div>
        </section>
        <hr class="m-0" />
      </div>
    );
}

export default Intrests;